<template>
    <div class="flex items-center justify-center w-full h-full">
        <hts-card>
            <template v-if="loading">
                <p>
                    Đang xác thực lời mời, vui lòng đợi trong giây lát
                </p>
                <progress class="progress w-full" />
            </template>
            <template v-else>
                <p v-if="error">
                    Xác thực không thành công
                </p>
                <p v-else>
                    Xác thực thành công
                </p>
            </template>
        </hts-card>
    </div>
</template>
<script lang="ts" setup>
const route = useRoute()
const store = $store()
const loading = ref(true)
const error = ref(false)
const { auth } = $store()

definePageMeta({
  layout: 'auth'
})

const token = computed(() => {
  return String(route.query?.token)
})

onMounted(async () => {
  const api = $url.auth.acceptInvitation
  const res: any = await $api(api, {
    body: {
      token: token.value
    }
  })

  const resData = $lodash.get(res, 'data.value')

  if (resData?.success) {
    loading.value = false

    process.client && $toast().success('Chấp nhận lời mời thành công')

    const workspace = resData.data.workspace
    const companyType = resData.data.companyType
    const cooperatorTypes = resData.data.cooperatorTypes || []

    if (!workspace) {
      // To-do: trang chưa có workspace
      return
    }

    store.userConfig.workspaces = [workspace]
    store.userConfig.companyTypes = [companyType]
    const { _sid, companyType: companyTypeW, timezone, type } = workspace
    const workspaceId = _sid
    auth.setWorkspace({ id: _sid, companyType: companyTypeW, timezone, type, cooperatorTypes })

    setTimeout(() => {
      if (cooperatorTypes.includes('PARTNER')) {
        useRouter().push({
          name: 'pp-id',
          params: { id: workspaceId }
        })
      } else if (cooperatorTypes.includes('CUSTOMER')) {
        useRouter().push({
          name: 'pc-id',
          params: { id: workspaceId }
        })
      } else {
        useRouter().push({
          name: 'pp-id',
          params: { id: workspaceId }
        })
      }
    }, 2000)
  } else {
    loading.value = false
    error.value = true
  }
})
</script>
